export const formatDate = (dateString?: string) => {
  const date = dateString ? new Date(dateString) : new Date();

  if (isNaN(date.getTime())) return dateString ?? "";

  const time = date.toLocaleString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  const day = date.getDate();
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();

  return `${time.toLowerCase()}, ${day} ${month} ${year}`;
};

// Format date to DD / MM / YY format for display
export const formatDateParts = (date: string | Date | undefined) => {
  if (!date) return { day: "--", month: "--", year: "--" };

  const dateObj = typeof date === "string" ? new Date(date) : date;

  // Check if valid date
  if (isNaN(dateObj.getTime())) return { day: "--", month: "--", year: "--" };

  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const year = String(dateObj.getFullYear()).slice(-2);

  return { day, month, year };
};

export const getRelativeTime = (dateString: string) => {
  const date = new Date(dateString);
  const now = new Date();

  if (isNaN(date.getTime())) return dateString;

  const diffInMs = now.getTime() - date.getTime();

  // Handle future dates (shouldn't happen for call history, but just in case)
  if (diffInMs < 0) {
    return "just now";
  }

  const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
  const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  if (diffInMinutes < 1) {
    return "just now";
  } else if (diffInMinutes < 60) {
    return `${diffInMinutes} ${diffInMinutes === 1 ? "min" : "mins"} ago`;
  } else if (diffInHours < 24) {
    return `${diffInHours} ${diffInHours === 1 ? "hour" : "hours"} ago`;
  } else {
    if (diffInDays > 2) {
      return formatDate(dateString);
    } else {
      return `${diffInDays} ${diffInDays === 1 ? "day" : "days"} ago`;
    }
  }
};

export const formatFollowupDate = (dateString: string) => {
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    weekday: "short",
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const formatFollowupTime = (dateString?: string | null) => {
  if (!dateString) return "";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  return date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

// export function getRelativeTime(date: string | Date) {
//   const now = new Date();
//   const past = new Date(date);

//   const diffInSeconds = Math.floor((now.getTime() - past.getTime()) / 1000);

//   if (diffInSeconds < 60) return "Just now";

//   const minutes = Math.floor(diffInSeconds / 60);
//   if (minutes < 60) return `${minutes} min${minutes > 1 ? "s" : ""} ago`;

//   const hours = Math.floor(minutes / 60);
//   if (hours < 24) return `${hours} hour${hours > 1 ? "s" : ""} ago`;

//   const days = Math.floor(hours / 24);
//   if (days < 7) return `${days} day${days > 1 ? "s" : ""} ago`;

//   const weeks = Math.floor(days / 7);
//   if (weeks < 4) return `${weeks} week${weeks > 1 ? "s" : ""} ago`;

//   const months = Math.floor(days / 30);
//   if (months < 12) return `${months} month${months > 1 ? "s" : ""} ago`;

//   const years = Math.floor(days / 365);
//   return `${years} year${years > 1 ? "s" : ""} ago`;
// }
